import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Showreport} from '../showreport.model';

@Component({
  selector: 'app-showreport-list-item',
  templateUrl: './showreport-list-item.component.html',
  styleUrls: ['./showreport-list-item.component.scss'],
  standalone: false
})
export class ShowreportListItemComponent {

  @Input() showreport: Showreport;
  @Input() isSelected: boolean = false;
  @Input() embedded: boolean = false;

  @Output() selected = new EventEmitter<number>();

  /**
   * Get the name of who submitted the showreport.
   * Falls back to stagemanager for legacy showreports.
   */
  public get submittedByName(): string | null {
    // Prefer lastEditedBy (dynamic showreports)
    if (this.showreport?.updatedBy) {
      const {firstName, lastName} = this.showreport.updatedBy;
      return `${firstName || ''} ${lastName || ''}`.trim() || null;
    }


    // Fallback 1 submittedBy (dynamic showreports)
    if (this.showreport?.submittedBy) {
      const {firstName, lastName} = this.showreport.submittedBy;
      return `${firstName || ''} ${lastName || ''}`.trim() || null;
    }

    // Fall back to stagemanager (legacy showreports)
    if (this.showreport?.stagemanager) {
      const {firstName, lastName} = this.showreport.stagemanager;
      return `${firstName || ''} ${lastName || ''}`.trim() || null;
    }

    return null;
  }

  /**
   * Get the show's primary color for the accent border.
   * Falls back to grey if not set.
   */
  public get accentColor(): string | null {
    return this.showreport?.performance?.show?.primaryColor || null;
  }

  /**
   * Check if this showreport has technical checks to display.
   */
  public get hasTechnicalChecks(): boolean {
    // Check for dynamic showreport fields
    if (this.showreport?.fieldValues?.length > 0) {
      return this.showreport.fieldValues.some(
        f => f.fieldType === 'CHECKBOX' || f.fieldType === 'TECHNICAL_ITEM'
      );
    }

    // Check for legacy showreport fields
    return !!(
      this.showreport?.lightCheck !== undefined ||
      this.showreport?.audioCheck !== undefined
    );
  }

  /**
   * Handle item click for embedded mode.
   * In embedded mode, emits selection event instead of navigating.
   * In normal mode, lets the routerLink handle navigation.
   */
  public onItemClick(event: Event): void {
    if (this.embedded && this.showreport?.id) {
      event.preventDefault();
      event.stopPropagation();
      this.selected.emit(this.showreport.id);
    }
    // If not embedded, let the routerLink handle navigation
  }
}
